var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_80785)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_775_80785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 4.99902H2C1.44772 4.99902 1 5.44674 1 5.99902V13.999C1 14.5513 1.44772 14.999 2 14.999H10C10.5523 14.999 11 14.5513 11 13.999V12.999H12V13.999C12 15.1036 11.1046 15.999 10 15.999H2C0.895432 15.999 2.3539e-06 15.1036 0 13.999V5.99902C0 4.89445 0.89543 3.99902 2 3.99902H3V4.99902ZM14 -0.000976562C15.1046 -0.000974219 16 0.894455 16 1.99902V9.99902C16 11.1036 15.1046 11.999 14 11.999H6C4.89543 11.999 4 11.1036 4 9.99902V1.99902C4 0.894454 4.89543 -0.000976562 6 -0.000976562H14ZM6 0.999023C5.44772 0.999023 5 1.44674 5 1.99902V9.99902C5 10.5513 5.44772 10.999 6 10.999H14C14.5523 10.999 15 10.5513 15 9.99902V1.99902C15 1.44674 14.5523 0.999026 14 0.999023H6Z",
    fill: "#6C757D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_80785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_775_80785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconLight);
export default __webpack_public_path__ + "static/media/copy-icon-light.1e5439b604f192dd2132387485554daa.svg";
export { ForwardRef as ReactComponent };